import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltip } from '@angular/material/tooltip';
import { RouterLink } from '@angular/router';
import { LucideBell, LucideSettings } from '@lucide/angular';

/**
 * Les écrans de réglage des processus CDT. Ouvert à tout utilisateur interne : chaque écran se
 * consulte par tous, et ne se modifie que par les rôles habilités (RG-notification-droit-de-regler).
 */
@Component({
  selector: 'app-menu-settings',
  imports: [MatButtonModule, MatMenuModule, MatTooltip, RouterLink, LucideSettings, LucideBell],
  templateUrl: './menu-settings.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./menu-settings.scss'],
})
export class MenuSettings {}
